import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { AuthService, ValidatorsService } from 'src/app/shared/services';
import { PasswordModule } from 'primeng/password';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CardModule,
        FormsModule,
        ReactiveFormsModule,
        MessageModule,
        ButtonModule,
        CommonModule,
        PasswordModule,
        MessageModule,
        ToastModule
    ],
    standalone: true,
    providers: [MessageService],
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    styles: [
        `
    :host ::ng-deep .p-inputtext{
      width: 100%;
    }
    `
    ]
})
export class CreatePasswordComponent {

  private fb = inject(FormBuilder);
  private ms = inject(MessageService)
  private authService = inject(AuthService);
  private router = inject(Router);
  public validator = inject(ValidatorsService);
  public loadingOp = false;
  
  public resetPassword = this.fb.group({
    password: ['', Validators.required],
    repeatPassword: ['', Validators.required]
  },
  {
    validators: [
      this.validator.isFieldOneEqualFieldTwo('password','repeatPassword')
    ]
  }
  );

  isValidField( field: string ) {
    return this.validator.isValidField( this.resetPassword, field );
  }

  async onSubmit() {
    this.loadingOp =  true;
    const {password} = this.resetPassword.value;
    
    const resp:{error:string | null, access:boolean} = await this.authService.completeUserAccess(password!);
    if (resp.error) {
      this.loadingOp = false;
      this.ms.add({severity:'error', summary:'Error', detail:'Ha pasado demasiado tiempo desde que iniciaste sesión, por favor autentícate e inténtalo de nuevo'});
    } else {
      this.loadingOp = false;
      this.router.navigate(['/app/overview']);
    }
  }

  async reauthenticate() {
    setTimeout(async () => {
      await this.authService.logout();
      this.router.navigate(['/auth/login']);
    }, 3000)
  }

}
